enum routeUrls {
  HOME = "/",
  PROJECT = "/project",
  BLOGG = "/blogg",
  WORK = "/workexp",
  ABOUT = "/about",
  TEST = "/test",
  LOGIN = "/login",
  ADMIN = "/admin",
  CONNECT = "/connect",
  TRAINING = "/training",
  TRAINING_PLAN = "/training-plan",
  TRAINING_HISTORY = "/training-history",
  PLANNER = "/planner",
  PLACES = "/places",
  FOOD = "/food",
  BOOKS = "/books",
  BIKES = "/bikes",
  HEM = "/hem",
  ROLLERSKI = "/rullskidor",
  TODO = "/attgora",
  PROJEKT = "/projekt",
  TRADERA = "/tradera",
  LIFTS = "/traningslogg",
  SKIGAME = "/rullskidspel",
  MEKPORTAL = "/maskiningenjor",
}
export default routeUrls;
